import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function Quesadillas() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Quesadillas</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>1 tbsp sunflower oil
        <br></br>1 onion, finely chopped<br></br>2 garlic cloves, finely chopped
        <br></br>1 tsp cumin seeds<br></br>
        400g can pinto or kidney beans, rinsed and drained<br></br>2 tsp smoked
        paprika<br></br>8 flour tortillas<br></br>
        100g cheddar or gruyère, coarsely grated<br></br>
        Handful coriander leaves<br></br>
        200g tub fresh tomato salsa, plus extra to serve<br></br>
        Soured cream, to serve<br></br>
      </Typography>

      <Typography>
        STEP 1 <br></br>
        Heat the oil in a large frying pan and cook the onion and garlic for 2
        mins. <br></br>
        Add the cumin and cook for 1 min more. <br></br>
        Tip in the beans, paprika and a splash of water.<br></br>
        Using a potato masher, break the beans down as they warm through to make
        a rough purée. <br></br>
        Season generously.<br></br>
        <br></br>
        STEP 2<br></br>
        Spread the refried beans onto 4 of the tortillas and scatter over the
        cheese and coriander.<br></br>
        Spoon over the salsa, then top with the remaining tortillas to make 4
        sandwiches. <br></br>
        Wipe the frying pan with kitchen paper and return to the heat or heat a
        griddle pan. <br></br>
        Cook each sandwich for 1-2 mins on each side until the tortillas are
        crisp and golden and the cheese is melting. <br></br>
        Serve warm, cut into wedges, with extra salsa and soured cream for
        dipping.<br></br>
      </Typography>
    </Card>
  );
}
